@if (isLoading) {
    <div class="ticket-container" [style]="'--corp-color-1: ' + corpColor+ ';'" role="status" aria-live="polite" aria-busy="true">
        <span class="visually-hidden">{{ 'Loading' | translate }}</span>
        <div class="ticket mb-3">
            <div class="row justify-content-between mt-1 mb-1">
                <div class="price-info col-5 col-md-5">
                    <p-skeleton styleClass="w-50 mt-1"></p-skeleton>
                    <p-skeleton styleClass="w-25 mt-2"></p-skeleton>
                </div>
                <div class="col-md-3 col-5">
                    <p-skeleton styleClass="w-100" height="50px"></p-skeleton>
                    <p-skeleton styleClass="w-100" height="50px"></p-skeleton>
                </div>
            </div>
            <div class="row justify-content-between mt-1 mb-1">
                <div class="price-info col-5 col-md-5">
                    <p-skeleton styleClass="w-50 mt-1"></p-skeleton>
                    <p-skeleton styleClass="w-25 mt-2"></p-skeleton>
                </div>
                <div class="col-md-3 col-5">
                    <p-skeleton styleClass="w-100" height="50px"></p-skeleton>
                    <p-skeleton styleClass="w-100" height="50px"></p-skeleton>
                </div>
            </div>
        </div>
        <div class="total-box">
            <p-skeleton styleClass="w-50"></p-skeleton>
        </div>
    </div>
}

@if (!isLoading) {
    <div class="ticket-container pb-3" [style]="'--corp-color-1: ' + corpColor + ';'" aria-busy="false">
        <div class="ticket mb-1">
            @if (availableTickets() != null && !waitingListUserDetails) {
                @if (availableTickets() < 10 && availableTickets() > 1) {
                  <div class="mb-3 text-danger">
                  {{ ticketKey('OnlyXPlacesLeft') | translate: { n: availableTickets() } }}
                  </div>
                }
                @if (availableTickets() < 10 && availableTickets() == 1) {
                  <div class="mb-3 text-danger">
                  {{ ticketKey('Only1PlaceLeft') | translate }}
                  </div>
                }
                @if (availableTickets() <= 0) {
                  <div class="mb-3 text-danger">
                    {{ exceededKey() | translate }}
                  </div>
                }
              }

            @for (price of visiblePrices(); track price.id) {
              <div class="buy-section mt-1 mb-1">
                <div class="price-info d-flex flex-column gap-1">
                    <span class="fw-600">{{ price.name }}</span>
                    @if (price.total != 0) {
                      <span class="price-text">{{ price.total | currency:'€' }}</span>
                    }
                    @if (price.total == 0) {
                      <span class="price-text">{{ 'Free' | translate }}</span>
                    }

                    @if(availableByPrice[price.id]?.freePlaces !== null) {
                      <div class="text-danger">
                        @if(availableByPrice[price.id].freePlaces > 1) {
                          {{ ticketKey('MAX_SALES_CUSTOM_MESSAGE') | translate: { value: availableByPrice[price.id].freePlaces } }}
                        } @else if (availableByPrice[price.id].freePlaces === 1){
                          {{ ticketKey('Only1PlaceLeft') | translate }}
                        } @else if (availableByPrice[price.id].freePlaces <= 0) {
                          {{ exceededKey() | translate }}
                        }
                      </div>
                    }
                </div>
                <div>
                  @if ((availableByPrice[price.id]?.freePlaces == null) || (availableByPrice[price.id].freePlaces > 0)) {
                    <p-inputNumber
                        styleClass="input-width"
                        class="input-width"
                        (ngModelChange)="onChangeQty($event, price)"
                        [(ngModel)]="price.qty"
                        [showButtons]="true"
                        buttonLayout="horizontal"
                        inputId="horizontal"
                        spinnerMode="horizontal"
                        [step]="1"
                        incrementButtonIcon="pi pi-plus"
                        decrementButtonIcon="pi pi-minus"
                        [min]="0"
                        [max]="(maxPerPrice[price.id] ?? maxByAccessCode()) ?? 99"
                        tabindex="-1"
                      />
                  }
                  @if (availableByPrice[price.id]?.freePlaces != null && availableByPrice[price.id].freePlaces <= 0 && ticket?.waitingList) {
                    <button type="button" class="waiting-list-btn buy-btn rounded fw-bold" (click)="openWaitingListForPrice(price.id)">
                      <i class="fa fa-list-ul me-1" aria-hidden="true"></i>{{ 'INSCRIPTIONS.JoinWaitingList' | translate }}
                    </button>
                  }
                </div>
              </div>
            }
        </div>

    </div>
}
